import React from 'react';
// import target_1 from '../../assets/images/target-001.png';
// import target_2 from '../../assets/images/target-002.png';
// import target_3 from '../../assets/images/target-003.png';
import bgFooter from '../../assets/images/footer-layout.jpg';

const TargetsSection = () => {
  return (
    // <div className="w-full">
    //   <div className="max-w-[1000px] m-auto flex justify-around md:justify-between flex-wrap gap-2 md:gap-5 lg:gap-15">
    //     <div className="w-[45%] md:w-[30%] lg:w-[28%]">
    //       <div className="w-20 md:w-25 lg:w-32 m-auto mb-2">
    //         <img src={target_1} alt="Mục tiêu" />
    //       </div>
    //       <div>
    //         <h2 className="text-sm md:text-xl font-bold text-center text-[#3F8AFA]">MỤC TIÊU</h2>
    //         <p className="text-sm font-medium md:text-justify pt-2">
    //           Lan tỏa tinh thần tương thân tương ái, thúc đẩy cộng đồng cùng chung tay vì một xã hội
    //           nhân văn và bền vững
    //         </p>
    //       </div>
    //     </div>
    //     <div className="w-[45%] md:w-[30%] lg:w-[28%]">
    //       <div className="w-20 md:w-25 lg:w-32 m-auto mb-2">
    //         <img src={target_2} alt="Đối tượng" />
    //       </div>
    //       <div>
    //         <h2 className="text-sm md:text-xl font-bold text-center text-[#3F8AFA]">ĐỐI TƯỢNG</h2>
    //         <p className="text-sm font-medium md:text-justify pt-2">
    //           Mọi cá nhân và hộ gia đình cần được trợ giúp trên khắp 63 tỉnh thành Việt Nam.
    //         </p>
    //       </div>
    //     </div>
    //     <div className="w-[45%] md:w-[30%] lg:w-[28%]">
    //       <div className="w-20 md:w-25 lg:w-32 m-auto mb-2">
    //         <img src={target_3} alt="Cam kết" />
    //       </div>
    //       <div>
    //         <h2 className="text-sm md:text-xl font-bold text-center text-[#3F8AFA]">CAM KẾT</h2>
    //         <p className="text-sm font-medium md:text-justify pt-2">
    //           Minh bạch về tài chính, sử dụng hiệu quả mọi nguồn lực và đồng hành lâu dài cùng các
    //           mảnh đời thiếu may mắn.
    //         </p>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <div className="w-full mt-2">
      <img src={bgFooter} alt="GK88" className="bg-footer" />
    </div>
  );
};

export default TargetsSection;
